import React, { useEffect } from 'react';
import { useCallback } from 'react';
import CellCheckbox from './CellCheckbox';
import CellCard from './CellCard';
import { ICellCheckboxGroup } from './types';
import Toast from '../toast';
import { useTranslation } from 'react-i18next';

const CellCheckboxGroup = ({
  options,
  values,
  onChange,
  disabled,
  maxLength,
  inputProps,
  ...rest
}: ICellCheckboxGroup) => {
  const { t } = useTranslation();
  const handleChange = useCallback(
    (v: string | number) => {
      if (disabled) {
        return;
      }
      const isAdd = values.findIndex((i) => i === v) === -1;

      if (isAdd && maxLength && values.length >= maxLength) {
        Toast.info(
          maxLength > 1
            ? t('select_max_tips', { maxLength })
            : t('select_max_one_tips', { maxLength }),
        );
        return;
      }

      const _vs = isAdd ? [...values, v] : values.filter((i) => i !== v);
      onChange && onChange(_vs);
    },
    [disabled, maxLength, values, onChange, t],
  );

  useEffect(() => {
    return () => {
      Toast.destroy();
    };
  }, []);

  return (
    <CellCard {...rest}>
      {options.map((item) => (
        <CellCheckbox
          inner
          key={item.value}
          value={item.value as any}
          title={item.title}
          description={item.description}
          checked={values.includes(item.value)}
          disabled={disabled || item.disabled}
          onClick={handleChange}
          {...inputProps}
        />
      ))}
    </CellCard>
  );
};

export default CellCheckboxGroup;
